import Icon from '../../components/Icon.vue'

Icon.register({"regular/image":{"width":512,"height":512,"paths":[{"d":"M464 64H48C21.5 64 0 85.5 0 112V400C0 426.5 21.5 448 48 448H464C490.5 448 512 426.5 512 400V112C512 85.5 490.5 64 464 64zM458 400H54A6-6 0 0 0 48 394V118A6-6 0 0 0 54 112H458A6-6 0 0 0 464 118V394A6-6 0 0 0 458 400zM128 152C105.9 152 88 169.9 88 192S105.9 232 128 232 168 214.1 168 192 150.1 152 128 152zM96 352H416V272L328.5 184.5C323.8 179.8 316.2 179.8 311.5 184.5L192 304 152.5 264.5C147.8 259.8 140.2 259.8 135.5 264.5L96 304V352z"}]}})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/regular/image.js
// module id = 0sYG
// module chunks = 0